import { useEffect, useState } from "react";
import { resolveArtistApiBaseUrl } from "../utils/artistApi";

const useDocData = () => {
  const [docData, setDocData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const normalizedBase = resolveArtistApiBaseUrl();
      const endpoint = normalizedBase
        ? `${normalizedBase}/public/artists`
        : "/public/artists";

      try {
        const response = await fetch(endpoint);
        if (!response.ok) {
          throw new Error("Failed to load artists");
        }
        const data = await response.json();
        const artists = Array.isArray(data) ? data : data.artists;
        setDocData(Array.isArray(artists) ? artists : []);
      } catch (err) {
        console.error(err);
        setDocData([]);
      }
    }

    fetchData();
  }, []);

  return [docData];
};

export default useDocData;
